import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import {
    DiscrepancyNotificationMapping,
    DiscrepancyNotificationStatus,
    StationDiscrepancyNotification,
} from '@models/station-discrepancy';

@Component({
    selector: 'app-notification-field',
    imports: [MatIconModule, CommonModule],
    template: `
        @if (notification !== null) {
            <span class="flex items-center gap-5">
                <mat-icon
                    [svgIcon]="notificationProperty.icon"
                    [ngClass]="'color-' + notificationProperty.iconColor" />
                <span [ngClass]="'color-' + notificationProperty.labelColor">
                    {{ label }}
                </span>
            </span>
        } @else {
            -
        }
    `,
    styles: `
        ::ng-deep.mat-icon {
            display: flex;
        }
    `,
})
export class NotificationFieldComponent {
    @Input({ required: true }) notification!: StationDiscrepancyNotification;

    get notificationProperty() {
        return DiscrepancyNotificationMapping[this.notification.status];
    }

    get label() {
        if (
            this.notification.status === DiscrepancyNotificationStatus.Escalated
        ) {
            return (
                this.notificationProperty.label + ' L' + this.notification.value
            );
        }
        return this.notificationProperty.label;
    }
}
